import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgAppleLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 747.63776 909.28345",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M45.3 72h13v15.8h-13V71.9z" })
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "#b3b3b3",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "matrix(54.85033 0 0 -54.85033 -2466 4835)",
			clipPath: "url(#a)",
			children: /* @__PURE__ */ _jsx("path", { d: "M56.1 79.4c0 2 1.6 3 1.7 3A3.7 3.7 0 0 1 55 84c-1.2 0-2.4-.8-3-.8-.6 0-1.6.7-2.6.7-1.4 0-2.6-.8-3.3-2-1.4-2.4-.4-6 1-8 .7-1 1.4-2 2.5-2 1 0 1.4.7 2.6.7 1.2 0 1.5-.7 2.6-.7 1 0 1.8 1 2.4 2 .8 1.1 1.1 2.2 1.1 2.3 0 0-2 .8-2.1 3.2" })
		}), /* @__PURE__ */ _jsx("path", { d: "M501.8 158.5c30.3-36.8 50.9-88 45.2-139-43.8 1.8-96.7 29.2-128.2 66C390.7 118 366 170 372.7 220c48.8 3.8 98.7-24.9 129-61.6" })]
	})]
});
export default SvgAppleLogo;
